// 项目详情store
import * as investApi from '@/api/project/invest'

const state = {
	projectId: null,
	basicInfo: {},
	// 项目详情中默认所有模块
	projectBtnGroup: [{
		title: '详情',
		key: 'detail',
		perms: 'C/B/I/A/A'
	}, {
		title: '进度',
		key: 'progress',
		perms: 'C/B/I/D/A',
		modeList:[
			// {title:'甘特图模式', key:'gantt', perms: ''},
			{title:'任务模式', key:'task', perms: ''},
		]
	},{
		title: '基本信息',
		key: 'info',
		perms: 'C/B/I/B/A'
	},{
		title: '计划',
		key: 'plan',
		perms: 'C/B/I/C/A',
		btnList:[
			{title:'进度计划', key:'processPlan', perms: ''},
			{title:'计划历史', key:'planHistory', perms: ''},
		]
	},{
		title: '关联人员',
		key: 'person',
		perms: 'C/C/A'
	},{
		title: '投放详情',
		key: 'throw',
		perms: 'C/B/I/E/A'
	}],
	projectBtnGroupAfterRole: [],  //经过登录后重新计算的tab
	projectBtnIndex: 0,  //大的详情tab下标
	projectBtn: {},      //当前点击的tab
	planBtnIndex: 0, //计划模块中按钮下标(进度计划)
	modeBtnIndex: 1, //进度模块下的按钮下标(甘特图模式)
	isWinOpen: false, //详情是否是展开页面
	planTemplate: {},  //计划模板
	summary: {},   //计划摘要
	curExecutePlan: {},  //当前执行计划
	planHistory: [],  //计划历史
	person: {},	//关联人
	loading: {
		// loading 相关的
		default: false,
		weatherAndAddress: false,   //天气地址详情中
		summaryLoading: false,	  //计划摘要详情中
		planWholeLoading: false,	//计划总体进度详情中
		historyLoading: false,	  //进度模块中进度历史列表
		updateProgressLoading: false,  //进度更新详情中
		investmentRatioLoading: false	//详情中投放比例
	},
	isExistExecute: false,   //是否存在执行计划
	isExistApprove: false,   //是否存在审批计划
	planWholeProgress: null,  //计划整体进度
	planTabs: [],			 //计划模块
	report: {},			   //进度历史中点击详情选中的当前报告
	investSummary: {},		//投放整体详情
	investList: {},		//投放分页列表
	updateProgressList: [],    //详情中进度更新列表
}

const getters = {
	projectId: state => state.projectId,
	basicInfo: state => state.basicInfo,
	projectBtnGroup: state => state.projectBtnGroup,
	projectBtnGroupAfterRole: state => state.projectBtnGroupAfterRole,
	projectBtnIndex: state => state.projectBtnIndex,
	projectBtn: state => state.projectBtn,
	planBtnIndex: state => state.planBtnIndex,
	modeBtnIndex: state => state.modeBtnIndex,
	isWinOpen: state => state.isWinOpen,
	planTemplate: state => state.planTemplate,
	summary: state => state.summary,
	curExecutePlan: state => state.curExecutePlan,
	planHistory: state => state.planHistory,
	isExistExecute: state => state.isExistExecute,
	isExistApprove: state => state.isExistApprove,
	planWholeProgress: state => state.planWholeProgress,
	planTabs: state => state.planTabs,
	person: state => state.person,
	report: state => state.report,
	investSummary: state => state.investSummary,
	investList: state => state.investList,
	updateProgressList: state => state.updateProgressList
}

const mutations = {
	// 设置项目id
	GET_PROJECTID: (state, payload) => {
		state.projectId = payload.projectId
	},
	// 获取项目详情中tab下标
	GET_PROJECTBTNINDEX: (state,payload)=>{
		state.projectBtnIndex=payload.index
	},
	// 获取计划模块中tab 下标
	GET_PLANBTNINDEX: (state, payload) => {
		state.planBtnIndex = payload.planBtnIndex
	},
	// 获取进度模块中tab 下标
	GET_MODEBTNINDEX: (state, payload) => {
		state.modeBtnIndex = payload.modeBtnIndex
	},
	//获取项目基本信息
	GET_BASICINFO: (state, payload) => {
		state.basicInfo = payload.basicInfo
	},
	// 详情页是否打开
	GET_ISWINOPEN: (state, payload) => {
		state.isWinOpen = payload.isWinOpen
	},
	// 获取计划模板
	GET_PLANTEMPLATE: (state, payload) => {
		state.planTemplate = payload.planTemplate
	},
	// 获取计划摘要
	GET_SUMMARY: (state, payload) => {
		state.summary = payload.summary
	},
	//获取当前执行模板
	GET_CUREXECUTEPLAN: (state, payload) => {
		state.curExecutePlan = payload.curExecutePlan
	},
	// 获取计划历史
	GET_PLANHISTORY: (state, payload) => {
		state.planHistory = payload.planHistory
	},
	// loading相关的 默认的
	GET_LOADING: (state, payload) => {
		state.loading.default = payload.loading
	},
	// 详情中天气loading
	GET_WEATHERADDLOADING: (state, payload) => {
		state.loading.weatherAndAddress = payload.loading
	},
	// 详情中计划loading
	GET_SUMMARYLOADING: (state, payload) => {
		state.loading.summaryLoading = payload.loading
	},
	// 详情整体计划loading
	GET_PLANWHOLELOADING: (state, payload) => {
		state.loading.planWholeLoading = payload.loading
	},
	// 进度历史loading
	GET_HISTORYLOADING: (state, payload) => {
		state.loading.historyLoading = payload.loading
	},
	// 进度更新列表
	GET_UPDATEPROGRESSLOADING: (state, payload) => {
		state.loading.updateProgressLoading = payload.loading
	},
	// 详情中投放模块
	GET_INVESTMENTRATIOLOADING: (state, payload) => {
		state.loading.investmentRatioLoading = payload.loading
	},
	// 设置是否执行中
	GET_ISEXISTEXECUTE: (state, payload) => {
		state.isExistExecute = payload.flag
	},
	// 设置是否审批中
	GET_ISEXISTAPPROVE: (state, payload) => {
		state.isExistApprove = payload.flag
	},
	// 获取计划整体进度
	GET_PLANWHOLEPROGRESS: (state, payload) => {
		state.planWholeProgress = payload.whole
	},
	// 获取计划模块
	GET_ALLPLANTABS: (state,payload) => {
		state.planTabs = payload.planTabs
	},
	// 获取关联人
	GET_PERSON: (state,payload) => {
		state.person = payload.personList
	},
	GET_REPORT: (state, payload) => {
		state.report = payload.report
	},
	// 获取投放整体详情
	GET_INVESTSUMMARY: (state, payload) => {
		state.investSummary = payload.summary
	},
	// 获取投放分页列表
	GET_INVESTLIST: (state, payload) => {
		state.investList = payload.investList
	},
	// 获取更新进度列表
	GET_UPDATEPROGRESSLIST: (state, payload) => {
		state.updateProgressList = payload.updateProgressList
	},
	// 获取登录账号后的项目详情中的tab
	GET_ROLE_PROJECTBTNGROUP: (state, payload) => {
		// // 获取ls 中的buttonPermissions
		// let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
		// let {group} = payload
		// // 获取到新的权限
		// let newGroup = group.filter(g => buttonPermissions.includes(g.perms))
		state.projectBtnGroupAfterRole = payload.group
	},
	// 获取点击的tab按钮内容
	GET_PROJECTBTN: (state, payload) => {
		state.projectBtn = payload.content
	}
}

const actions = {

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}




// WEBPACK FOOTER //
// ./src/store/modules/projectDetail.js